export const QUEST_TREASURE_COLLECTION_STORAGE_KEY =
  "vocabularium_quest_treasure_collection";

const MENU_SCROLL_STORAGE_KEY = "vocabularium_quest_treasure_collection_menu_scroll";

export function readQuestTreasureCollectionMenuScroll() {
  try {
    const value = Number(localStorage.getItem(MENU_SCROLL_STORAGE_KEY));
    return Number.isFinite(value) && value > 0 ? Math.round(value) : 0;
  } catch {
    return 0;
  }
}

export function writeQuestTreasureCollectionMenuScroll(scrollTop) {
  const value = Number.isFinite(scrollTop) && scrollTop > 0 ? Math.round(scrollTop) : 0;
  try {
    localStorage.setItem(MENU_SCROLL_STORAGE_KEY, String(value));
  } catch {
    // ignore quota / privacy mode errors
  }
}

/**
 * @param {number} collectionCount
 * @param {number} [defaultIndex=0] Collection ouverte quand rien n'est mémorisé
 *   (première visite) — ex. celle de la relique de bienvenue.
 */
export function readQuestTreasureCollectionIndex(collectionCount, defaultIndex = 0) {
  if (!Number.isFinite(collectionCount) || collectionCount < 1) return 0;
  const fallback =
    Number.isInteger(defaultIndex) && defaultIndex >= 0 && defaultIndex < collectionCount
      ? defaultIndex
      : 0;

  try {
    const raw = localStorage.getItem(QUEST_TREASURE_COLLECTION_STORAGE_KEY);
    if (raw == null) return fallback;
    const index = parseInt(raw, 10);
    if (!Number.isFinite(index) || index < 0 || index >= collectionCount) return fallback;
    return index;
  } catch {
    return fallback;
  }
}

export function writeQuestTreasureCollectionIndex(collectionIndex) {
  try {
    localStorage.setItem(
      QUEST_TREASURE_COLLECTION_STORAGE_KEY,
      String(collectionIndex)
    );
  } catch {
    // ignore quota / privacy mode errors
  }
}
